<template></template>
<script setup lang="ts">
import { computed, ref, watch, onUnmounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { incomeTypes } from '@/utils/livechat';
import { useLivechatStore } from '@/stores/livechat';

const faviconActive = '/favicon-income/favicon-active.png';

const faviconList = [
  '/favicon.png',
  '/favicon-income/favicon-income-01.png',
  '/favicon-income/favicon-income-02.png',
  '/favicon-income/favicon-income-03.png',
  '/favicon-income/favicon-income-04.png',
  '/favicon-income/favicon-income-04.png',
  '/favicon-income/favicon-income-05.png',
  '/favicon-income/favicon-income-06.png',
  '/favicon-income/favicon-income-07.png',
  '/favicon.png',
];

const livechatStore = useLivechatStore();
const { t } = useI18n();

const botHasLivechat = computed(() => livechatStore.botHasLivechatGetter);
const incomeType = computed(() => livechatStore.incomeType);
const isChatOpen = computed(() => livechatStore.isChatOpenGetter);

const titleInitial = document.title;
const titleUpdateInterval = ref<ReturnType<typeof setInterval> | null>(null);

function stopTitleUpdate() {
  if (titleUpdateInterval.value) {
    clearInterval(titleUpdateInterval.value);
  }
  titleUpdateInterval.value = null;
}

function init() {
  if (titleUpdateInterval.value) {
    stopTitleUpdate();
  }
  if (!botHasLivechat.value) {
    return;
  }

  // Prepare favicon images to avoid requests
  const faviconImageList = faviconList.map((path: string) => {
    const img = new Image();
    img.src = path;
    return img;
  });
  const favicon = document.querySelector('link[rel*="icon"]') as HTMLLinkElement | null;
  let faviconIndex = 0;

  const canvas = document.createElement('canvas');
  canvas.width = 60;
  canvas.height = 60;
  const context = canvas.getContext('2d');
  // active tab but no animation
  if (incomeType.value === incomeTypes.activeTab) {
    if (favicon) favicon.href = faviconActive;
    document.title = titleInitial;
    stopTitleUpdate();
    return;
  }

  const message =
    incomeType.value === incomeTypes.newChat
      ? t('livechat.newChat')
      : t('livechat.newMessage');
  let title = `${message} +++ moin.ai Hub +++`;
  let titleIndex = 0;

  if (!incomeType.value) {
    stopTitleUpdate();
    setTimeout(() => {
      if (favicon) favicon.href = faviconList[0]!;
      document.title = titleInitial;
    }, 300);
    return;
  }

  titleUpdateInterval.value = setInterval(() => {
    faviconIndex = (faviconIndex + 1) % faviconList.length;
    if (context) {
      context.clearRect(0, 0, canvas.width, canvas.height);
      context.drawImage(faviconImageList[faviconIndex]!, 0, 0);
      if (favicon) favicon.href = canvas.toDataURL('image/png');
    }

    if (titleIndex >= title.length) {
      titleIndex = 0;
    } else {
      titleIndex += 1;
    }
    const partA = title.substring(0, titleIndex);
    const partB = title.substring(titleIndex + 1);
    document.title = partB + ' ' + partA;
  }, 150);
}

watch(incomeType, () => {
  init();
});

watch(isChatOpen, () => {
  init();
});

// created hook
init();

onUnmounted(() => {
  if (titleUpdateInterval.value) {
    clearInterval(titleUpdateInterval.value);
  }
});
</script>
